import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const links = [
  { href: "#manifesto", label: "Manifesto" },
  { href: "#timeline", label: "Timeline" },
  { href: "#stack", label: "Stack" },
  { href: "#vision", label: "Vision" },
  { href: "#contact", label: "Contact" },
];

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6">
        <div
          className={`flex items-center gap-8 rounded-full px-5 py-2.5 transition-all duration-500 ${
            scrolled ? "glass" : ""
          }`}
        >
          <a href="#top" className="flex items-center gap-2 text-sm font-semibold tracking-tight">
            <span className="inline-block h-2 w-2 rounded-full bg-electric shadow-[0_0_12px_var(--electric)]" />
            Nithin Devadiga
          </a>
          <nav className="hidden items-center gap-6 md:flex">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-[13px] text-muted-foreground transition-colors hover:text-foreground"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
        <a
          href="#contact"
          className="glass hidden rounded-full px-4 py-2 text-[13px] font-medium transition-all hover:bg-white/10 md:inline-flex"
        >
          Connect →
        </a>
      </div>
    </motion.header>
  );
}
